import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Table } from 'react-bootstrap';

import { Web3StatusContext } from "../contexts/Web3StatusContext";
import TransactionStatus from './TransactionStatus'
import { Trans } from 'react-i18next';

const { AccountData, ContractData, ContractForm } = newContextComponents;

class Refund extends React.Component {
  static contextType = Web3StatusContext;
  lastBlock = 0;

  state = {
    bnbAmountDataKey: null,
    stackId: -1,
  };

  updateCalls() {
    if(this.lastBlock == this.context.blockNumber ||
          this.context.activeAccount == null)
      return;
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;

    const bnbAmountDataKey = contract.methods["depositsOf"].cacheCall(this.context.activeAccount);
    
    this.setState({ bnbAmountDataKey: bnbAmountDataKey});
  }

  componentDidMount() {
    this.updateCalls();
  }

  componentDidUpdate() {
    //this.updateCalls();
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFORESTSale } = drizzle.contracts;

    const stackId = GAMEFORESTSale.methods.refund.cacheSend(this.context.activeAccount);
    this.setState({ stackId: stackId });
  }

  // destructure drizzle and drizzleState from props
  render() {
    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }

    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    var disabled = this.context.activeAccount == null;
    var bnbAmount = 0;
    if(!disabled) {
      var bnbAmountContract = GAMEFORESTSale["depositsOf"]
              [this.state.bnbAmountDataKey];

      if(bnbAmountContract !== undefined) {
        bnbAmount = bnbAmountContract.value;
        bnbAmount = this.context.web3.utils.fromWei(bnbAmount, "ether");
      }
    }
    
    var msg = <Trans>refund.goal_not_met</Trans>;

    if(!disabled) {
      msg = (
      <div>
        {msg}<br/>
        <Trans>refund.amount_1</Trans>{bnbAmount}<Trans>refund.amount_2</Trans>
      </div>
      );
    }

    if(bnbAmount == 0 || bnbAmount == '0') {
      disabled = true;
    }

    var form = (
    <form onSubmit={this.mySubmitHandler}>
        {statusMsg}<br/>
        <input
        type='submit'
        value="Refund"
        disabled={disabled}
        />
    </form>
    );

    return (
      <div>
        {msg}
        {form}
      </div>
    );
  }
};

export default Refund;
